export default __webpack_public_path__ + "static/media/discover-off.9d37db80.svg";